import { LitElement } from 'lit';
import { html } from 'lit';
import { Subscription } from 'rxjs';
import { TemplateResult } from 'lit/development';
import { FormGroup } from '../../../../../../../../ui/gzForm/formGroup/form-group';
import { OnFormValidityChange } from '../events/events';
import { cloneDeep } from 'lodash';

export abstract class GzPolicyFullPageWindowFormWebComponent<T> extends LitElement {
  // form group
  protected formGroup: FormGroup;
  // subscription
  private subscription: Subscription;
  // value
  protected value: T | undefined;

  protected constructor(value?: T) {
    super();
    this.value = cloneDeep(value);
  }

  /**
   * Get the value of the form group.
   */
  get formValue() {
    return this.getConvertedFormValue();
  }

  /**
   * Set the error for component.
   * @param error
   */
  public setError(error: string) {}

  /**
   * Create form group and subscribe to valid.
   * @param changedProperties
   */
  protected firstUpdated(changedProperties) {
    super.firstUpdated(changedProperties);
    this.createFormGroup();
    this.setFormGroupValue();
    this.subscribeToValid();
  }

  /**
   * Render specific content.
   */
  protected render() {
    return html` <div class="policy-dialog-form">${this.renderContent()}</div> `;
  }

  /**
   * Unsubscribe from form group.
   */
  disconnectedCallback(): void {
    this.formGroup?.unsubscribe();
    this.subscription?.unsubscribe();
    super.disconnectedCallback();
  }

  /**
   * Subscribe to valid.
   */
  private subscribeToValid() {
    this.subscription = this.formGroup.valid$.subscribe({
      next: valid => {
        this.dispatchEvent(new OnFormValidityChange(valid));
      },
    });
  }

  /**
   * Implemented in child components to create form group.
   */
  protected abstract createFormGroup(): void;

  /**
   * Implemented in child components to set form group value.
   */
  protected abstract setFormGroupValue(): void;

  /**
   * Implemented in child components to render form fields.
   */
  protected abstract renderContent(): TemplateResult;

  /**
   * Implemented in child components to convert form value.
   */
  protected abstract getConvertedFormValue(): any;
}
